import SectionBlogHome from '../../components/Sections/SectionBlogHome'
import { Suspense, lazy, useEffect, useLayoutEffect, useState } from 'react'
import SectionSeparatedEnterprises from '../../components/Sections/SectionSeparatedEnterprises'
import SectionBestPropertiesFullText from '../../components/Sections/SectionBestPropertiesFullText/index2'
import SectionBestPropertiesFullTextBasic from '../../components/Sections/SectionBestPropertiesFullText/indexBasic'
import CardPatrocinadoByIndex from '../../components/Cards/CardPatrocinadoByIndex'
import Logo from '../../assets/glemo-logo.webp'
import UserLoginIcon from '../../assets/icons/blue-user.svg'
import CarouselConstructionCompanies from '../../components/Carousels/CarouselConstructionCompanies'
import { Button } from '../../components/common'
import { SelectLocal } from '../../components/SelectLocal'
import Header from '../../components/Header'
import HeaderMobile from '../../components/HeaderMobile'
import Footer from '../../components/Footer'

const SkeletonLoading = lazy(() => import('../../components/common/SkeletonLoading'))

interface Props {
  isDocumentReady?: boolean
}
export function Home({ isDocumentReady }: Props) {
  return (
    <>
      <main>
        {!isDocumentReady && (
          <>
            <header className="header-mobile px-4 bg-white top-0 pt-5 pb-2 fixed z-[99] md:hidden w-[100vw]">
              <div id="mobileContainerSearch">
                <div className="grid grid-cols-3">
                  <div className="m-auto ml-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      fill="currentColor"
                      className="text-glemo-blue"
                      viewBox="0 0 256 256"
                    >
                      <path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"></path>
                    </svg>
                  </div>
                  <div className="m-auto">
                    <a href={'/'}>
                      <Suspense fallback={<SkeletonLoading />}>
                        <img alt="Glemo Logo" src={Logo} className="w-full aspect-[191/69]" />
                      </Suspense>
                    </a>
                  </div>
                  <div className="m-auto mr-0">
                    <a href="/entrar">
                      <span className="text-blue-700 text-lg font-semibold tracking-wider">
                        <img src={UserLoginIcon} width={20} alt="User Icon" className="m-auto" />
                        <div className="-mt-[6px] text-[14px]">Entrar</div>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </header>
            <div className="hidden lg:block bg-white text-center py-3">
              {/* <a href={'/'} className="w-fit">
          <img alt="Glemo Logo" src={Logo} className="w-[100px] m-auto" />
        </a> */}
              <header
                className={
                  'desktop-header header w-full pt-2 top-0 pb-5 bg-off-white border-b border-gray-300 items-center justify-center z-[99] hidden md:block fixed'
                }
              >
                <div className="h-full w-full text-2xl flex flex-col justify-between m-auto">
                  <div className="w-full flex items-center gap-4 px-5 lg:px-10">
                    <span className="min-w-[129px] min-h-[78px] flex place-items-center">
                      <Suspense fallback={<SkeletonLoading />}>
                        <img
                          alt="Glemo Logo"
                          className="m-auto w-[129px] h-[47px]"
                          src={Logo}
                          width={129}
                          height={47}
                        />
                      </Suspense>
                    </span>

                    <div className="flex items-center gap-3 py-4 px-3 h-12 rounded border-1 border-gray-200 w-full focus-within:border-2 focus-within:border-blue-700 bg-gray-100">
                      <span className="w-6 h-6 text-blue-700">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          width="28"
                          height="28"
                          className="-mt-[4px] justify-self-center"
                          viewBox="0 0 256 256"
                        >
                          <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path>
                        </svg>
                      </span>
                      <input
                        id="enderecoBuscaEmpreendimento"
                        placeholder="Busque seu imóvel aqui"
                        className="w-[inherit] bg-gray-100 flex-1 text-md outline-none placeholder:text-gray-600 max-w-100"
                        value=""
                      />
                      <span className="w-6 h-6 text-blue-700">
                        <img
                          src="/src/assets/icons/separator-microphone-gray.svg"
                          className="w-1 -mt-[5px]"
                        />
                      </span>
                      <span className="w-6 h-6 text-blue-700">
                        <img
                          src="/src/assets/icons/microphone-blue.svg"
                          className="cursor-pointer"
                        />
                      </span>
                    </div>
                    <Button
                      variant="secondary"
                      aria-label="Filtrar"
                      id="openSectionFilter"
                      value="Filtrar"
                    >
                      <svg
                        width="19"
                        height="18"
                        viewBox="0 0 19 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.78573 9.02344H0.928589M18.0714 14.7377L15.2143 14.7377M18.0714 3.30915L10.6429 3.30916M8.35716 3.30915L0.92859 3.30915M6.07145 9.02344L18.0714 9.02344M12.9286 14.7377H0.92859M12.9286 12.452V17.0234L15.2143 17.0234V12.452L12.9286 12.452ZM3.78573 6.73772V11.3092H6.07145V6.73772H3.78573ZM8.35716 1.02344V5.59487H10.6429V1.02344L8.35716 1.02344Z"
                          stroke="#0059FF"
                        />
                      </svg>
                    </Button>
                    <Button
                      variant="primary"
                      id="filterBtnNavDesktop"
                      aria-label="Buscar"
                      value="Buscar"
                    >
                      <>BUSCAR </>
                    </Button>
                    <Button variant="transparent" id="headerNavVisualizados">
                      <div className="text-gray-700 px-0 py-0 hover:bg-gray-100 flex justify-center items-center gap-2.5 rounded transition-colors ease-in-out duration-250">
                        <span className="bg-gray-100 text-blue-700 rounded px-4 py-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            width="20"
                            viewBox="0 0 256 256"
                          >
                            <path d="M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm-8-48A95.44,95.44,0,0,0,60.08,60.15C52.81,67.51,46.35,74.59,40,82V64a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16H49c7.15-8.42,14.27-16.35,22.39-24.57a80,80,0,1,1,1.66,114.75,8,8,0,1,0-11,11.64A96,96,0,1,0,128,32Z"></path>
                          </svg>
                        </span>
                        <span className="font-semibold tracking-wider pr-4 md:hidden lg:inline-block">
                          Visualizados
                        </span>
                      </div>
                    </Button>

                    <Button variant="transparent" id="headerNavFavoritos">
                      <div className="text-gray-700 px-0 py-0 hover:bg-gray-100 flex justify-center items-center gap-2.5 rounded transition-colors ease-in-out duration-250">
                        <span className="bg-gray-100 text-blue-700 rounded px-4 py-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            fill="currentColor"
                            viewBox="0 0 256 256"
                          >
                            <path d="M178,32c-20.65,0-38.73,8.88-50,23.89C116.73,40.88,98.65,32,78,32A62.07,62.07,0,0,0,16,94c0,70,103.79,126.66,108.21,129a8,8,0,0,0,7.58,0C136.21,220.66,240,164,240,94A62.07,62.07,0,0,0,178,32ZM128,206.8C109.74,196.16,32,147.69,32,94A46.06,46.06,0,0,1,78,48c19.45,0,35.78,10.36,42.6,27a8,8,0,0,0,14.8,0c6.82-16.67,23.15-27,42.6-27a46.06,46.06,0,0,1,46,46C224,147.61,146.24,196.15,128,206.8Z"></path>
                          </svg>
                        </span>
                        <span className="font-semibold tracking-wider pr-4 md:hidden lg:inline-block">
                          Favoritos
                        </span>
                      </div>
                    </Button>

                    <span className="text-blue-700 flex text-lg font-semibold tracking-wider">
                      <span className="me-2 inline-block">Entrar</span>
                      <img
                        src={UserLoginIcon}
                        width={20}
                        alt="User Icon"
                        className="m-auto inline-block"
                      />
                    </span>
                  </div>
                  <hr className="my-4 opacity-[0.2]" />
                  <div className="dropdowns-menu w-full text-xl text-black-60 flex items-center justify-center gap-16">
                    <SelectLocal />
                    <button className="flex items-center gap-1 font-semibold cursor-pointer">
                      Para Empresas
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        fill="currentColor"
                        viewBox="0 0 256 256"
                      >
                        <rect width="256" height="256" fill="none"></rect>
                        <polyline
                          points="208 96 128 176 48 96"
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        ></polyline>
                      </svg>
                    </button>
                    <button className="flex items-center gap-1 font-semibold cursor-pointer">
                      Para você
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        fill="currentColor"
                        viewBox="0 0 256 256"
                      >
                        <rect width="256" height="256" fill="none"></rect>
                        <polyline
                          points="208 96 128 176 48 96"
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        ></polyline>
                      </svg>
                    </button>
                    <button className="flex items-center gap-1 font-semibold cursor-pointer">
                      Sobre o glemO
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        fill="currentColor"
                        viewBox="0 0 256 256"
                      >
                        <rect width="256" height="256" fill="none"></rect>
                        <polyline
                          points="208 96 128 176 48 96"
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        ></polyline>
                      </svg>
                    </button>
                  </div>
                </div>
              </header>
            </div>
          </>
        )}
        {!isDocumentReady ? (
          <>
            <SectionBestPropertiesFullTextBasic />
            <div id="loadingBox" className=""></div>
            <div className='hidden lg:block'>
              <div className="container-responsive-view gap-4 mt-10">
                <h2 className="text-4xl lg:text-6xl mb-5 text-black font-bold">
                  <>
                    <span className="overline decoration-[#F15C00]">Baseados </span>
                    na sua localização
                  </>
                </h2>
                <p className="text-xl">Descubra as nossas principais escolhas próximas a você.</p>
              </div>
              <div id="loadingBox"></div>
            </div>
          </>
        ) : (
          <>
            {window.innerWidth > 1029 ? <Header /> : <HeaderMobile />}
            <div className={`md:mt-[135px] mt-[50px]`}>
              <div id="containerHomeBestProperties" className="">
                <SectionBestPropertiesFullText />
              </div>
              <div className="container-after-search">
                <div className="container-construction-companies container-responsive-view mt-auto">
                  <CarouselConstructionCompanies />
                </div>
              </div>
              <section className="container-responsive-view gap-4 mt-10">
                <Suspense fallback={<div className="loadingBox"></div>}>
                  <SectionSeparatedEnterprises isHome />
                </Suspense>
              </section>
              <>
                {window.innerWidth >= 1024 ? (
                  <div className="SectionBlogHome mt-10 block lg:mt-auto">
                    <Suspense fallback={<SkeletonLoading />}>
                      <SectionBlogHome seeMore />
                    </Suspense>
                  </div>
                ) : (
                  <div className="SectionBlogHome mt-10 block lg:mt-auto">
                    <Suspense fallback={<SkeletonLoading />}>
                      <SectionBlogHome seeMore isCarousel />
                    </Suspense>
                  </div>
                )}
                <div className="my-5 container-responsive-view">
                  <Suspense fallback={<SkeletonLoading height={200} />}>
                    <CardPatrocinadoByIndex position={3} />
                  </Suspense>
                </div>
              </>
            </div>
            <Footer />
          </>
        )}
      </main>
    </>
  )
}
